// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import tagGroupEntity from './entities/tag-group.json';
import tagGroupMenu from '../pages/tag-group/menu.json';
import tagGroupFullForm from '../pages/tag-group/forms/full.json';
import tagGroupContextForm from '../pages/tag-group/forms/context.json';
import tagGroupMiniForm from '../pages/tag-group/forms/mini.json';
import tagGroupLookupForm from '../pages/tag-group/forms/lookup.json';
import tagGroupTableView from '../pages/tag-group/views/table.json';
import tagGroupDashboardView from '../pages/tag-group/views/dashboard.json';

/** Тип запису «Група тегів» зі сторінками пакета: меню, форми та подання з pages/tag-group/. */
export const tagGroupDefinition: IRecordTypeDefinition = {
  ...tagGroupEntity,
  views: assembleViewSet({
      table: tagGroupTableView,
      dashboard: tagGroupDashboardView,
  }),
  form: tagGroupFullForm,
  forms: { full: tagGroupFullForm, context: tagGroupContextForm, mini: tagGroupMiniForm, lookup: tagGroupLookupForm },
  menu: tagGroupMenu,
} as IRecordTypeDefinition;
